// import React from 'react'
// import styled from 'styled-components'
// // import footimage1 from '../Assets/tayyab__1_-removebg-preview.png'
// import footimage from '../Assets/GalaxyDiscount.png'
// import { FaInstagram } from 'react-icons/fa';
// import { FaTwitter } from 'react-icons/fa';
// import { FaLinkedin } from 'react-icons/fa';
// import { FaFacebook } from 'react-icons/fa';
// import { SiPinboard } from "react-icons/si";
// import { FaWhatsapp } from "react-icons/fa";
// import { IoMdNavigate } from "react-icons/io";

// import { AiOutlineCopyright } from "react-icons/ai";
// import { FiPhoneCall } from "react-icons/fi";
// import { SlLocationPin } from "react-icons/sl";
// const Wrap = styled.div`
// width:100%;
// height:100%;
// box-sizing: border-box;
// `
// const ContanierFoot = styled.div`
//     color:white;
//     background-color: #171764;
//     height: 350px;
//     box-sizing: border-box;
//     width:100%;
//     @media screen and (max-width:600px){
//   height: 800px;
// }
// @media screen and (min-width: 601px) and (max-width:849px) {

//   height:970px;
// }
// @media screen and (min-width: 850px) and (max-width:1100px) {

//   height:500px;
// }
// `
// const ContanierLogo = styled.div`
// width: 100%;
// /* display: flex; */
// height: 70px;

// `
// const ContanierColum = styled.div`
// width: 100%;
// /* background-color:red; */
// padding-left: 140px;
// margin-top: 10px;
// height:260px;
// display: flex;
// gap: 10px;
// box-sizing:border-box;
// @media screen and (max-width:600px){
//   display: flex;
//   flex-direction: column;
//   padding:0px;
//   /* background-color: red; */
//   height:690px;
//   gap: 0px;
// }
// @media screen and (min-width:601px) and (max-width:849px){
//   display: flex;
//   flex-direction: column;
//   padding:0px;
//   /* background-color: red;; */
//   height:880px;
//   gap: 0px;
// }
// @media screen and (min-width: 850px) and (max-width:1100px) {
//   padding: 10px;
//   height:400px;
//   padding-left: 30px;
//   padding-top: 50px;
//   margin-top:30px;
// }

// `
// const ContanierOne = styled.div`
// color:white;
// width: 30%;
// margin-top: 10px;
// /* background-color: green; */
// @media screen and (max-width:600px){
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
//   margin-top: 40px;
//   line-height: 25px;
//   width: 100%;
// }
// @media screen and (min-width: 601px) and (max-width:849px){
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
//   width: 100%;
// }
// @media screen and (min-width: 850px) and (max-width:1100px) {
//   width:33%;
//   height: auto;
// }
// `
// const ContanierTwo = styled.div`
// width: 30%;
// margin-top: 7px;
// color:white;
// padding: 15px;
// padding-left:70px;
// /* background-color: #ff00bf; */
// @media screen and (max-width:600px){
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   padding-left:10px;
//   align-items: center;
//   text-align: center;
//   padding-bottom: 0px;
// }
// @media screen and (min-width:601px) and (max-width:849px){
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   padding-left:10px;
//   align-items: center;
//   text-align: center;
//   padding-bottom: 0px;
// }
// @media screen and (min-width: 850px) and (max-width:1100px) {

// }

// `
// const ContanierThree = styled.div`
// width: 30%;
// margin-top: 10px;
// color:white;
// /* background-color:blue; */
// @media screen and (max-width:600px){
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   align-items: center;
//   text-align: center;
//   padding-top:0px;
//   line-height: 22px;
// }
// @media screen and (min-width:601px) and (max-width:849px){
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   align-items: center;
//   text-align: center;
//   padding-top:0px;
//   line-height: 22px;
// }
// @media screen and (min-width: 850px) and (max-width:1100px) {
//  width: 40%;
// }
// `
// const FoorImage = styled.img`
// width: 120px;
// height: 120px;
// padding-top:15px;
// margin-left:140px;

// @media screen and (max-width:600px){
//   margin-left: 10px;
// }
// @media screen and (min-width: 601px) and (max-width:849px) {
//   margin-left: 30px;
//   margin-top: 30px;

// }
// @media screen and (min-width: 850px) and (max-width:1100px) {
//   margin-left: 30px;
//   margin-top: 30px;

// }
// `
// const HeadText = styled.h1`
//   font-size: 1.3rem;
//   margin: 10px;
//   @media screen and (max-width:600px)
//   {
//     font-size:1rem;
//     margin:0px;
//     /* margin-left:10px; */
//     margin-top:8px;
//   }
// `
// const ParaText = styled.p`
// font-size:1rem;
// margin:10px;
// @media screen and (max-width:600px)
//   {
//     font-size:1rem;
//     margin:0px;
//     /* margin-left:10px; */
//     line-height: 35px;

//   }
// `
// const HeadText1 = styled.h1`
//   font-size: 1.7rem;
//   color: #e9b60f;
//   @media screen and (max-width:600px)
//   {

//     margin-left:30px;
//     margin-top:30px;

//   }
// `

// const InstagramIcon = styled(FaInstagram)`
//   color: #fdfcfc; /* Instagram brand color */
//   font-size: 2rem; /* Adjust the size as needed */
//   transition: color 0.3s ease;

//   &:hover {
//     color: #E1306C; /* Change color on hover */
//     background-color: white;
//   }
//   @media screen and (max-width:600px){
//   display: flex;

// }
// `;
// const TwitterIcon = styled(FaTwitter)`
//   color: #f6f6f7; /* Twitter brand color */
//   font-size: 2rem; /* Adjust the size as needed */
//   transition: color 0.3s ease;

//   &:hover {
//     background-color: white;
//     color: #1DA1F2; /* Change color on hover */
//   }
//   @media screen and (max-width:600px){
//   display: flex;

// }
// `;
// const LinkedInIcon = styled(FaLinkedin)`
//   color: #f5f7f8; /* LinkedIn brand color */
//   font-size: 2rem; /* Adjust the size as needed */
//   transition: color 0.3s ease;

//   &:hover {
//     color: #0A66C2; /* Change color on hover */
//     background-color: white;
//   }

// `;
// const FacebookIcon = styled(FaFacebook)`
// /* background-color: white; */

//   color: #fafafa; /* Facebook brand color */
//   font-size: 2rem; /* Adjust the size as needed */
//   transition: color 0.3s ease;

//   &:hover {
//     background-color: white;
//     color: #1877F2; /* Change color on hover */
//   }
// `;
// const ScrollButton = styled.button`
//   background-color: white;
//   color: black;
//   border: none;
//   padding: 0.5rem 1rem;
//   cursor: pointer;
//   font-size: 1rem;
//   position: absolute;
//   bottom: 1rem;

//   &:hover {
//     background-color: black;
//     color:white;
//   }

//   @media screen and (max-width:600px){
//     margin-right: 60px;
//     margin-bottom: 40px;
//   }
// `;
// const FooterContainer = styled.footer`
//   background-color: #363434;
//   padding: 1rem;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   color: #fff;
//   position: absolute;
//   margin-left: 90%;
// `;
// const Icons = styled.div`
// display: flex;
// gap: 20px;
//   @media screen and (max-width:849px){
//   display: none;

// }

// `
// const Icons1 = styled.div`
// display: flex;
// gap: 20px;
//   @media screen and (max-width:850px){
//   display: flex;
//   margin: 20px;
// }
// @media screen and (min-width:851px){
//   display: none;

// }

// `

// const Contanier1Foot2 = styled.p`
// width:100%;
// height:70px;
// align-items: center;
// text-align: center;
// justify-content: center;
// display: flex;
// background-color:black;
// color:white;
// @media screen and (max-width:600px){
//   font-size: 8px;

// }
// `
// const HeadUnderLine = styled.p`
// text-decoration: underline;
// `

// const IconsLinks = styled.a``

// const Footer = () => {
//   const handleScrollToNavbar = () => {
//     document.querySelector('nav').scrollIntoView({ behavior: 'smooth' });
//   };
//   return (
//     <>
//       <Wrap>

//         <ContanierFoot>
//           <ContanierLogo>
//             <FoorImage src={footimage} alt="Foot Image Not Found" />
//             <FooterContainer>

//               <ScrollButton onClick={handleScrollToNavbar}><IoMdNavigate /></ScrollButton>
//             </FooterContainer>
//           </ContanierLogo>
//           <ContanierColum>

//             <ContanierOne>
//               <HeadText>The The Galaxy Of Discounts:</HeadText>
//               {/* <ParaText>Address:  Hawali Ramyana Wali, Kasur</ParaText> */}
//               {/* <HeadText><SlLocationPin /> Pakistan:</HeadText> */}
//               {/* <ParaText>Address:  Hawali Ramyana Wali Stree no: 1, Kasur.</ParaText> */}
//               <HeadText>We Offer Amazon’s Best & Hottest Deals. Anybody can locate what they need.</HeadText>
//               {/* <ParaText><FiPhoneCall /> +923436701675</ParaText> */}
//             </ContanierOne>
//             <ContanierTwo>
//               <HeadText>Home</HeadText>
//               <HeadText>About Us</HeadText>
//               <HeadText>Services</HeadText>
//               <HeadText>Blog</HeadText>
//               <HeadText>Contect Us</HeadText>
//               <HeadText1>Follow Us</HeadText1>
//               <Icons1>
//                 <IconsLinks href='https://www.instagram.com/processcritical?igsh=MXV1NTA5emZ3OHp4aQ==' target='_blank' rel="noopener noreferrer">
//                   <InstagramIcon />
//                 </IconsLinks>

//                 <IconsLinks href="https://wa.me/yourwhatsappphonenumber" target="_blank" rel="noopener noreferrer">
//   <FaWhatsapp />
// </IconsLinks>

//                 <IconsLinks href='http://linkedin.com' target='_blank' rel='noopener noreferrer'>
//                   <LinkedInIcon />
//                 </IconsLinks>

//                 <IconsLinks href='http://facebook.com' target='_blank' rel = "noopener noreferrer">
//                   <FacebookIcon />
//                 </IconsLinks>

//               </Icons1>
//             </ContanierTwo>
//             <ContanierThree>
//               <HeadText>Amazon Disclosure:</HeadText><br></br>
//               <ParaText> <b>The Galaxy Of Discounts is a partner in the Amazon Associates Program. We are the sole Amazon Affiliate Program commission earners.</b></ParaText>
//               {/* <ParaText> <b>PPC MANAGEMENT</b></ParaText> */}
//               {/* <ParaText><SiPinboard /> <b>INVENTERY MANAGMENT</b></ParaText> */}
//               {/* <ParaText><SiPinboard /> <b>AMAZON SEO</b></ParaText> */}
//               {/* <ParaText><SiPinboard /> <b>BRAND PROTECTION</b></ParaText> */}

//               <Icons>
//                 <IconsLinks href='http://instagram.com' target='_blank' rel="noopener noreferrer">
//                   <InstagramIcon />
//                 </IconsLinks>

//                 <IconsLinks href='http://google.com' target='_blank' rel="noopener noreferrer" >
//                   <TwitterIcon />
//                 </IconsLinks>

//                 <IconsLinks href='https://www.linkedin.com' target='_blank' rel='noopener noreferrer'>
//                   <LinkedInIcon />
//                 </IconsLinks>

//                 <IconsLinks href='https://www.facebook.com' target='_blank' rel = "noopener noreferrer">
//                   <FacebookIcon />
//                 </IconsLinks>

//               </Icons>

//             </ContanierThree>
//           </ContanierColum>
//         </ContanierFoot>
//         <Contanier1Foot2>
//           Copyright <AiOutlineCopyright /> &nbsp; 2022 Developed by &nbsp; <HeadUnderLine> usamanoor6613@gmail.com</HeadUnderLine>. &nbsp; All Rights Reserved.
//         </Contanier1Foot2>
//       </Wrap>
//     </>
//   )
// }

// export default Footer

import React from "react";
import styled from "styled-components";
import footimage from "../Assets/AzDania.png";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { IoMdNavigate } from "react-icons/io";
import { AiOutlineCopyright } from "react-icons/ai";

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;
const ContanierFoot = styled.div`
  color: white;
  background-color: #171764;
  height: 350px;
  box-sizing: border-box;
  width: 100%;
  @media screen and (max-width: 600px) {
    height: 800px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    height: 970px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    height: 500px;
  }
`;
const ContanierLogo = styled.div`
  width: 100%;
  height: 70px;
`;
const ContanierColum = styled.div`
  width: 100%;
  padding-left: 140px;
  margin-top: 10px;
  height: 260px;
  display: flex;
  gap: 10px;
  box-sizing: border-box;
  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    padding: 0px;
    height: 690px;
    gap: 0px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    display: flex;
    flex-direction: column;
    padding: 0px;
    height: 880px;
    gap: 0px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    padding: 10px;
    height: 400px;
    padding-left: 30px;
    padding-top: 50px;
    margin-top: 30px;
  }
`;
const ContanierOne = styled.div`
  color: white;
  width: 30%;
  margin-top: 10px;
  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 40px;
    line-height: 25px;
    width: 100%;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    width: 33%;
    height: auto;
  }
`;
const ContanierTwo = styled.div`
  width: 30%;
  margin-top: 7px;
  color: white;
  padding: 15px;
  padding-left: 70px;
  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 10px;
    align-items: center;
    text-align: center;
    padding-bottom: 0px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 10px;
    align-items: center;
    text-align: center;
    padding-bottom: 0px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
  }
`;
const ContanierThree = styled.div`
  width: 30%;
  margin-top: 10px;
  color: white;
  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    text-align: center;
    padding-top: 0px;
    line-height: 22px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    text-align: center;
    padding-top: 0px;
    line-height: 22px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    width: 40%;
  }
`;
const FoorImage = styled.img`
  width: 120px;
  height: 120px;
  padding-top: 15px;
  margin-left: 140px;

  @media screen and (max-width: 600px) {
    margin-left: 10px;
  }
  @media screen and (min-width: 601px) and (max-width: 849px) {
    margin-left: 30px;
    margin-top: 30px;
  }
  @media screen and (min-width: 850px) and (max-width: 1100px) {
    margin-left: 30px;
    margin-top: 30px;
  }
`;
const HeadText = styled.h1`
  font-size: 1.3rem;
  margin: 10px;
  @media screen and (max-width: 600px) {
    font-size: 1rem;
    margin: 0px;
    margin-top: 8px;
  }
`;
const ParaText = styled.p`
  font-size: 1rem;
  margin: 10px;
  @media screen and (max-width: 600px) {
    font-size: 1rem;
    margin: 0px;
    line-height: 35px;
  }
`;
const HeadText1 = styled.h1`
  font-size: 1.7rem;
  color: #e9b60f;
  @media screen and (max-width: 600px) {
    margin-left: 30px;
    margin-top: 30px;
  }
`;

const InstagramIcon = styled(FaInstagram)`
  color: #fdfcfc; /* Instagram brand color */
  font-size: 2rem; /* Adjust the size as needed */
  transition: color 0.3s ease;

  &:hover {
    color: #e1306c; /* Change color on hover */
    background-color: white;
  }
  @media screen and (max-width: 600px) {
    display: flex;
  }
`;
const LinkedInIcon = styled(FaLinkedin)`
  color: #f5f7f8; /* LinkedIn brand color */
  font-size: 2rem; /* Adjust the size as needed */
  transition: color 0.3s ease;

  &:hover {
    color: #0a66c2; /* Change color on hover */
    background-color: white;
  }
`;
const FacebookIcon = styled(FaFacebook)`
  color: #fafafa; /* Facebook brand color */
  font-size: 2rem; /* Adjust the size as needed */
  transition: color 0.3s ease;

  &:hover {
    background-color: white;
    color: #1877f2; /* Change color on hover */
  }
`;
const WhatsappIcon = styled(FaWhatsapp)`
  color: #25d366; /* WhatsApp brand color */
  font-size: 2rem; /* Adjust the size as needed */
  transition: color 0.3s ease;

  &:hover {
    background-color: white;
    color: #25d366; /* Change color on hover */
  }
`;
const ScrollButton = styled.button`
  background-color: white;
  color: black;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 1rem;
  position: absolute;
  bottom: 1rem;

  &:hover {
    background-color: black;
    color: white;
  }

  @media screen and (max-width: 600px) {
    margin-right: 60px;
    margin-bottom: 40px;
  }
`;
const FooterContainer = styled.footer`
  background-color: #363434;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  position: absolute;
  margin-left: 90%;
`;
const Icons = styled.div`
  display: flex;
  gap: 20px;
  @media screen and (max-width: 849px) {
    display: none;
  }
`;
const Icons1 = styled.div`
  display: flex;
  gap: 20px;
  @media screen and (max-width: 850px) {
    display: flex;
    margin: 20px;
  }
  @media screen and (min-width: 851px) {
    display: none;
  }
`;

const Contanier1Foot2 = styled.p`
  width: 100%;
  height: 70px;
  align-items: center;
  text-align: center;
  justify-content: center;
  display: flex;
  background-color: black;
  color: white;
  @media screen and (max-width: 600px) {
    font-size: 8px;
  }
`;
const HeadUnderLine = styled.p`
  text-decoration: underline;
`;

const IconsLinks = styled.a``;

const Footer = () => {
  const handleScrollToNavbar = () => {
    document.querySelector("nav").scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <Wrap>
        <ContanierFoot>
          <ContanierLogo>
            <FoorImage src={footimage} alt="Foot Image Not Found" />
            {/* <FooterContainer> */}
            {/* <ScrollButton onClick={handleScrollToNavbar}><IoMdNavigate /></ScrollButton> */}
            {/* </FooterContainer> */}
          </ContanierLogo>
          <ContanierColum>
            <ContanierOne>
              <HeadText>The AzDania:</HeadText>
              <HeadText>
                We Offer Amazon’s Best & Hottest Deals. Anybody can locate what
                they need.
              </HeadText>
            </ContanierOne>
            <ContanierTwo>
              <HeadText>Home</HeadText>
              <HeadText>About Us</HeadText>
              <HeadText>Services</HeadText>
              <HeadText>Blog</HeadText>
              <HeadText>Contect Us</HeadText>
              <HeadText1>Follow Us</HeadText1>
              <Icons1>
                <IconsLinks
                  href=" https://www.instagram.com/mairashahzadi53?igsh=YzljYTk1ODg3Zg=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon />
                </IconsLinks>

                <IconsLinks
                  href="https://wa.me/qr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsappIcon />
                </IconsLinks>

                <IconsLinks
                  href="http://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon />
                </IconsLinks>

                <IconsLinks
                  href="https://www.facebook.com/profile.php?id=100094397767656&mibextid=ZbWKwL"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookIcon />
                </IconsLinks>
              </Icons1>
            </ContanierTwo>
            <ContanierThree>
              <HeadText>Amazon Disclosure:</HeadText>
              <br></br>
              <ParaText>
                {" "}
                <b>
                  The AzDania is a partner in the Amazon Associates
                  Program. We are the sole Amazon Affiliate Program commission
                  earners.
                </b>
              </ParaText>
              <Icons>
                <IconsLinks
                  href=" https://www.instagram.com/mairashahzadi53?igsh=YzljYTk1ODg3Zg=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon />
                </IconsLinks>

                <IconsLinks
                  href="https://wa.me/message/CAB5TQAMPYSVG1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsappIcon />
                </IconsLinks>

                <IconsLinks
                  href="https://www.linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon />
                </IconsLinks>

                <IconsLinks
                  href="https://www.facebook.com/profile.php?id=100094397767656&mibextid=ZbWKwL"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookIcon />
                </IconsLinks>
              </Icons>
            </ContanierThree>
          </ContanierColum>
        </ContanierFoot>
        <Contanier1Foot2>
          Copyright <AiOutlineCopyright /> &nbsp; 2022 Developed by &nbsp;{" "}
          <HeadUnderLine> bd9305013@gmail.com</HeadUnderLine>. &nbsp; All
          Rights Reserved.
        </Contanier1Foot2>
      </Wrap>
    </>
  );
};

export default Footer;
